import React, { PropsWithChildren } from "react";

interface Props {
  root?: boolean;
}

interface State {
  hasError: boolean;
  error?: Error;
  errorInfo?: React.ErrorInfo;
}

export class ErrorBoundary extends React.Component<
  PropsWithChildren<Props>,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);

    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    const { root } = this.props;
    const { hasError, error, errorInfo } = this.state;

    // If the error boundary is at the root of the app, we want to show a generic error message
    if (hasError && root) {
      return (
        <div className="container">
          <div className="hs vs">
            <div className="error-boundary">
              <h1>
                Beklager, noe har gått galt i visningen av denne nettsiden!
              </h1>
              <p>
                Hvis du opplever denne feilen, gi beskjed til oss direkte på
                telefon eller mail.
              </p>

              <details>
                <summary>Feilmeldingsdetaljer</summary>
                <div className="error-boundary-details">
                  <h2>{error && error.toString()}</h2>
                  <p>{errorInfo && errorInfo.componentStack}</p>
                </div>
              </details>
            </div>
          </div>
        </div>
      );
    }

    // If the error boundary is not at the root of the app, we want to render nothing
    // so that the other parts of the website can still be used.
    if (hasError && !root) {
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
